import { FairtransportMembershipType } from './FairtransportMembershipType';
import type { TenantRoute } from './TenantRouteType';

export type TenantProfileType = {
    activeSubscription: boolean,
    allabolagUrl: string,
    billingCity: string,
    billingEmail: string,
    billingMark: string,
    billingStreet: string,
    billingZip: string,
    cashRatio: number | null,
    city: string,
    companyStatus: string,
    customLicencesCertificates: string[],
    description: string,
    email: string,
    employerContributions: boolean,
    equipment: string[],
    equityRatio: number | null,
    fairtransportEmail: string,
    fairtransportDescription: string,
    fairtransportMembership: FairtransportMembershipType,
    fairtransportPhone: string,
    fairtransportUrl: string,
    fTax: boolean,
    industries: string[],
    isAccepted: boolean,
    isCarrier: boolean,
    isFairtransportMember: boolean,
    isPending: boolean,
    isPublic?: boolean,
    isRejected: boolean,
    lat: number,
    legalEntity: string,
    licencesCertificates: string[],
    lng: number,
    name: string,
    netResult: number | null,
    orgNumber: string,
    phone: string,
    profitAfterFinancialItems: number | null,
    profitMargin: number | null,
    scrapedAt: string | null,
    sniIndustries: string[],
    street: string,
    sustainability: string[],
    vat: boolean,
    vehicleTypes: string[],
    website: string,
    zip: string,
    fullAddress: string,
    fullBillingAddress: string,
    revenue: number | null,
    slug: string | null,
    numberOfTrucks: number | null,
    numberOfTrucksOverride: number | null,
    logoUrl: string | null,
    routes?: TenantRoute[],
    recommendedByCurrentTenant?: boolean
};

export const tenantProfileLabelMap = {
    revenue: 'Omsättning',
    profitAfterFinancialItems: 'Resultat efter finansnetto',
    netResult: 'Årets resultat',
    legalEntity: 'Bolagsform',
    cashRatio: 'Kassalikviditet',
    profitMargin: 'Vinstmarginal',
    equityRatio: 'Soliditet',
    companyStatus: 'Bolagets status',
    vat: 'Registrerad för moms',
    fTax: 'Innehar F-skatt',
    employerContributions: 'Arbetsgivaravgift',
    orgNumber: 'Org.nr',
    fullAddress: 'Adress',
    fullBillingAddress: 'Fakturaadress',
    billingEmail: 'Faktura-epost',
    billingMark: 'Fakturamärkning',
    activeSubscription: 'Premium-medlem',
    allabolagUrl: 'Allabolag länk',
    billingCity: 'Fakturerasstad',
    billingStreet: 'Fakturaadress',
    billingZip: 'Faktura-postnummer',
    city: 'Stad',
    customLicencesCertificates: 'Licenser och certifikat',
    description: 'Beskrivning',
    email: 'E-post',
    equipment: 'Utrustning',
    fairtransportEmail: 'Fairtransport e-post',
    fairtransportDescription: 'Fairtransport beskrivning',
    fairtransportMembership: 'Fairtransport medlemskap',
    fairtransportPhone: 'Fairtransport telefon',
    fairtransportUrl: 'Fair Transport',
    industries: 'Brancher',
    isAccepted: 'Accepterad',
    isCarrier: 'Transportör',
    isFairtransportMember: 'Fair Transport-medlem',
    isPending: 'Väntande',
    isPublic: 'Offentlig',
    isRejected: 'Avvisad',
    lat: 'Latitud',
    licencesCertificates: 'Licenser och certifikat',
    lng: 'Longitud',
    name: 'Namn',
    netSales: 'Nettoomsättning',
    numberOfRatings: 'Antal omdömen',
    phone: 'Telefon',
    rating: 'Betyg',
    scrapedAt: 'Hämtad',
    sniIndustries: 'SNI-branscher',
    street: 'Gata',
    sustainability: 'Hållbarhet',
    vehicleTypes: 'Fordonstyper',
    website: 'Hemsida',
    zip: 'Postnummer',
    numberOfTrucks: 'Antal lastbilar',
    numberOfTrucksOverride: 'Antal lastbilar'
} as const;

export type TenantProfileLabelKey = keyof typeof tenantProfileLabelMap;

export const getTenantProfileLabel = (key: TenantProfileLabelKey) => tenantProfileLabelMap[key];
